import { useRecordContext } from "react-admin";

export const ApproverField = ({ source = "approvedBy" }: { source?: string }) => {
  const record = useRecordContext();
  const approvedBy = record?.[source];

  if (!approvedBy) return null;

  // approvedBy is an object { userId, email?, name? } set server-side at
  // approval time, so it survives even if the user is later deleted.
  if (typeof approvedBy === "object") {
    return <>{approvedBy.name || approvedBy.email || approvedBy.userId}</>;
  }

  // Backward compatibility with older records where approvedBy was a plain userId string.
  return <>{approvedBy}</>;
};
